import styled from 'styled-components';

export const Wrapper = styled.div`
    display:flex;
    flex-direction: column;
    flex-grow: 1;
`;

export const Content = styled.div`
    height: calc(100vh - 150px);
    overflow-y:scroll;
    padding-bottom: 150px;
`;

export const DataEmpty = styled.div`
    text-align:center;
    font-size: 1rem;
    font-weight: 500;    
`;

export const Line = styled.div`
    padding-right: 4px;
`;

export const MLabel = styled.label`
    padding: 0 4px;
    color: #6c757d;
`;

export const GoodsImg = styled.img`
    max-width: 100px;
`;

export const SHeader = styled.div`
    padding: 3px 10px;
    background-color:#d3e8d8;    
`;